import {foundationTheme} from 'platform/foundation';
import {match} from 'ts-pattern';

import {catchUnhandledDataGridActions, handleApiError} from '@dms/shared';

import {
  BulkOperationConfirmForm,
  openBulkOperationActionDialog,
  type BulkOperationActionCallback,
} from 'features/eag-grid';

import {VehicleAdvertisingBulkForm} from '../components/VehicleAdvertisingBulkForm/VehicleAdvertisingBulkForm';
import {VehicleReassignBulkForm} from '../components/VehicleReassignBulkForm/VehicleReassignBulkForm';
import {VehicleSalesProgramBulkForm} from '../components/VehicleSalesProgramBulkForm/VehicleSalesProgramBulkForm';
import {VehicleTagsBulkForm} from '../components/VehicleTagsBulkForm/VehicleTagsBulkForm';
import {VehicleWarrantyBulkForm} from '../components/VehicleWarrantyBulkForm/VehicleWarrantyBulkForm';

export const vehicleBulkOperationActionCallback: BulkOperationActionCallback = (action) =>
  match(action.actionKey)
    .with('REASSIGN', () =>
      openBulkOperationActionDialog(action, <VehicleReassignBulkForm action={action} />)
    )
    .with('ARCHIVE', 'UNARCHIVE', () =>
      openBulkOperationActionDialog(
        action,
        <BulkOperationConfirmForm action={action} onError={handleApiError} />
      )
    )
    .with('SET_WARRANTY_PROGRAM', () =>
      openBulkOperationActionDialog(action, <VehicleWarrantyBulkForm action={action} />)
    )
    .with('SET_SALES_PROGRAM', () =>
      openBulkOperationActionDialog(action, <VehicleSalesProgramBulkForm action={action} />)
    )
    .with('ADD_TAG_VALUES', 'REMOVE_TAG_VALUES', () =>
      openBulkOperationActionDialog(action, <VehicleTagsBulkForm action={action} />)
    )
    .with(
      'SALES_ENABLE_VEHICLE_IN_ADVERTISEMENT',
      'SALES_DISABLE_VEHICLE_IN_ADVERTISEMENT',
      'SALES_DISABLE_PLATFORM_FOR_VEHICLE',
      'SALES_UPDATE_VEHICLE_PLATFORM',
      'SALES_REPEAT_LAST_PUBLISHING_ACTION',
      () =>
        openBulkOperationActionDialog(
          action,
          <VehicleAdvertisingBulkForm action={action} />,
          window.matchMedia?.(foundationTheme.devices.mobile)?.matches ? 'xLarge' : 'large'
        )
    )
    .otherwise(() => {
      catchUnhandledDataGridActions(action.actionKey);
    });
